<!--
 * @Author: hanhuixian hanhuixian@lxrental.com
 * @Description: 页面Html框架
-->
<template>
  <div class="rental-page">
    <!-- 页首 -->
    <HeaderBar />

    <!-- 内容主体 -->
    <router-view v-slot="{ Component }">
      <transition   mode="out-in">
        <keep-alive>
          <div :key="$route.path">
            <component :is="Component" />
          </div>
        </keep-alive>
      </transition >
    </router-view>

    <!-- 页脚 -->
    <FooterTools />
    <FooterBar />
  </div>
</template>

<script>
import HeaderBar from "@/layout/components/header-bar/header-bar.vue";
import FooterTools from "@/components/footer-tools.vue";
import FooterBar from "@/layout/components/footer-bar/footer-bar.vue";

export default {
  name: "HomeView",
  components: {
    HeaderBar,
    FooterTools,
    FooterBar
  },
};
</script>
